import React from "react";


import DashboardEcommerce from "../pages/DashboardEcommerce";





import Calendar from "../pages/Calendar";

// Project
import ProjectList from "../pages/Projects/ProjectList";
import ProjectOverview from "../pages/Projects/ProjectOverview";
import CreateProject from "../pages/Projects/CreateProject";
import CreateCourse from "../pages/Projects/CreateProject/index2";
import CourseList from "../pages/Projects/ProjectList/index2"
import InscriptionsList from "../pages/Projects/ProjectList/inscription"

import CryproOrder from "../pages/Crypto/CryptoOrder";






// Support Tickets
import ListView from "../pages/SupportTickets/ListView";

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceClients from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceProducts/EcommerceAddProduct";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceCategories from "../pages/Ecommerce/EcommerceSellers/index";




import BasicPasswReset from "../pages/AuthenticationInner/PasswordReset/BasicPasswReset";
//pages
import SimplePage from "../pages/Pages/Profile/SimplePage/SimplePage";
import Settings from "../pages/Pages/Profile/Settings/Settings";
import Team from "../pages/Pages/Team/Team";
import Timeline from "../pages/Pages/Timeline/Timeline";

import Basic403 from "../pages/AuthenticationInner/Errors/Basic404";


import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";


//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";



// Landing Index

// User Profile


import JobList from "../pages/Jobs/JobList/List";
import JobOverview from "../pages/Jobs/JobList/Overview";
import CandidateList from "../pages/Jobs/CandidateList/ListView";
import NewJobs from "../pages/Jobs/NewJob";



import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import EcommerceOrderDetail from "../pages/Ecommerce/EcommerceOrders/EcommerceOrderDetail";

// ProtectedRoute component to check role-based access
const ProtectedRoute = ({ allowedRoles }) => {
  // Get user role from Redux or localStorage
  const { user } = useSelector(state => ({
    user: state.Login.user,
  }));
  const userRole = user?.role || JSON.parse(localStorage.getItem('user') || '{}')?.role || 'unknown';
  if (!userRole) {
    Navigate("/login");
    return null; // Prevent further rendering
  }  // Check if the user's role is allowed for the route
  if (allowedRoles.includes(userRole)) {
    return <Outlet />;
  } else {
    return <Navigate to="/NotAuthorized" replace />;
  }
};

const routePermissions = {
  "/dashboard": ["admin", "support", "editor"],
  "/apps-job-details":["admin", "editor"],
  "/apps-calendar": ["admin", "editor"],
  "/apps-ecommerce-products": ["admin", "editor"],
  "/apps-ecommerce-product-details": ["admin", "editor"],
  "/apps-ecommerce-order-detail": ["admin","support", "editor"],
  "/apps-ecommerce-add-product": ["admin", "editor"],
  "/apps-ecommerce-edit-product": ["admin", "editor"],
  "/apps-ecommerce-clients": ["admin", "editor"],
  "/apps-ecommerce-orders": ["admin", "support", "editor"],
  "/apps-categories-list": ["admin", "editor"],
  "/apps-job-lists": ["admin", "editor"],
  "/apps-job-candidate-lists": ["admin", "editor"],
  "/apps-job-new": ["admin", "editor"],
  "/apps-projects-list": ["admin", "editor"],
  "/apps-projects-overview/:id": ["admin", "editor"],
  "/apps-projects-create": ["admin", "editor"],
  "/apps-inscriptions/:id": ["admin", "editor"],
  "/apps-courses-create": ["admin", "editor"],
  "/apps-courses-list": ["admin", "editor"],
  "/apps-tickets-list": ["admin", "support"],
  "/apps-demo-list": ["admin", "support", "editor"],
  "/pages-profile": ["admin", "editor"],
  "/pages-profile-settings": ["admin", "editor","support"],
  "/pages-team": ["admin"],
  "/pages-timeline": ["admin"],
  "/profile": ["admin", "editor","support"],

};

// Wrap authProtectedRoutes with ProtectedRoute
const authProtectedRoutes = [

  { path: "/dashboard", component: <DashboardEcommerce />, allowedRoles: routePermissions["/dashboard"] },
  { path: "/apps-calendar", component: <Calendar />, allowedRoles: routePermissions["/apps-calendar"] },
  { path: "/apps-ecommerce-products", component: <EcommerceProducts />, allowedRoles: routePermissions["/apps-ecommerce-products"] },
  { path: "/apps-ecommerce-clients", component: <EcommerceClients />, allowedRoles: routePermissions["/apps-ecommerce-clients"] },
  { path: "/apps-ecommerce-product-details/:id", component: <EcommerceProductDetail />, allowedRoles: routePermissions["/apps-ecommerce-product-details"] },
  { path: "/apps-ecommerce-add-product", component: <EcommerceAddProduct />, allowedRoles: routePermissions["/apps-ecommerce-add-product"] },
  { path: "/apps-ecommerce-edit-product/:id", component: <EcommerceAddProduct />, allowedRoles: routePermissions["/apps-ecommerce-edit-product"] },
  { path: "/apps-ecommerce-orders", component: <EcommerceOrders />, allowedRoles: routePermissions["/apps-ecommerce-orders"] },
  { path: "/apps-ecommerce-orders/:client", component: <EcommerceOrders />, allowedRoles: routePermissions["/apps-ecommerce-orders"] },
  { path: "/apps-categories-list", component: <EcommerceCategories />, allowedRoles: routePermissions["/apps-categories-list"] },
  { path: "/apps-ecommerce-order-details/:id", component: <EcommerceOrderDetail />, allowedRoles: routePermissions["/apps-ecommerce-order-detail"] },
  { path: "/apps-job-lists", component: <JobList />, allowedRoles: routePermissions["/apps-job-lists"] },
  { path: "/apps-job-candidate-lists", component: <CandidateList />, allowedRoles: routePermissions["/apps-job-candidate-lists"] },
  { path: "/apps-job-new", component: <NewJobs />, allowedRoles: routePermissions["/apps-job-new"] },
  { path: "/apps-resource-list", component: <ProjectList />, allowedRoles: routePermissions["/apps-projects-list"] },
  { path: "/apps-resource-overview/:id", component: <ProjectOverview />, allowedRoles: routePermissions["/apps-projects-overview/:id"] },
  { path: "/apps-resource-create", component: <CreateProject />, allowedRoles: routePermissions["/apps-projects-create"] },
  { path: "/apps-resource-edit/:resourceId", component: <CreateProject />, allowedRoles: routePermissions["/apps-projects-create"] },
  { path: "/apps-inscriptions/:id", component: <InscriptionsList />, allowedRoles: routePermissions["/apps-inscriptions/:id"] },
  { path: "/apps-courses-create", component: <CreateCourse />, allowedRoles: routePermissions["/apps-courses-create"] },
  { path: "/apps-courses-list", component: <CourseList />, allowedRoles: routePermissions["/apps-courses-list"] },
  { path: "/apps-tickets-list", component: <ListView />, allowedRoles: routePermissions["/apps-tickets-list"] },
  { path: "/apps-demo-list", component: <CryproOrder />, allowedRoles: routePermissions["/apps-demo-list"] },
  { path: "/pages-profile", component: <SimplePage />, allowedRoles: routePermissions["/pages-profile"] },
  { path: "/pages-profile-settings", component: <Settings />, allowedRoles: routePermissions["/pages-profile-settings"] },
  { path: "/pages-team", component: <Team />, allowedRoles: routePermissions["/pages-team"] },
  { path: "/pages-timeline", component: <Timeline />, allowedRoles: routePermissions["/pages-timeline"] },
  {path: "/apps-job-details", component: <JobOverview />, allowedRoles: routePermissions["/apps-job-details"]},
  { path: "*", component: <Navigate to="/NotAuthorized" />, allowedRoles: [] },
];

// Public routes remain unchanged
const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  {path:"/",component: <Login/>},
  { path: "/auth-pass-reset", component: <BasicPasswReset/> },
  { path: "/NotAuthorized", component: <Basic403 /> },
  { path: "/auth-pass-change/:token", component: <BasicPasswCreate /> },
];

export { authProtectedRoutes, publicRoutes, ProtectedRoute };